import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fill-height":"","fluid":""}},[_c(VCol,[_c(VRow,{attrs:{"align":"center","justify":"center"}},[(!!_vm.process_map_image)?_c(VImg,{staticClass:"my-3",attrs:{"src":_vm.process_map_image,"contain":"","max-height":"720px"}}):_c(VCard,{attrs:{"elevation":"1"}},[_c(VCardText,[_vm._v("\n          "+_vm._s(_vm.$vuetify.lang.translator('no_process_map'))+"\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }